// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Teal “Build Path” — compact; plain outline inputs use floatLabel never + placeholder */
.bp-shell {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  font-family: "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  color: #263238;
  -webkit-font-smoothing: antialiased;
}

.bp-title {
  margin: 0;
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 4px 12px;
  font-size: 0.9375rem;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #263238;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.bp-title.mat-mdc-dialog-title {
  padding: 4px 12px !important;
  margin: 0 !important;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

.bp-dialog {
  padding: 6px 12px 8px;
  max-height: calc(88vh - 104px);
  overflow: auto;
  background: #fff;
}

.bp-form {
  margin-top: 0;
}

.bp-steps {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.bp-step--filter-only {
  padding: 8px 0 10px;
  border-bottom: none;
}

.bp-step--filter-not-first {
  padding-top: 14px;
  margin-top: 4px;
  border-top: 1px solid #e0e0e0;
}

.bp-steps > .bp-step--filter-only:first-of-type .bp-step-header--segment {
  margin-top: 8px;
}

.bp-step-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 12px;
}

.bp-filter-optional-label {
  font-size: 0.625rem;
  font-weight: 500;
  color: #90a4ae;
  line-height: 1.2;
  margin-bottom: 10px;
}

.bp-step-num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.58rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(160deg, #4db6ac 0%, #00897b 55%, #00796b 100%);
  box-shadow: 0 1px 3px rgba(0, 105, 92, 0.16);
}

.bp-step-heading {
  margin: 0;
  flex: 1 1 auto;
  min-width: 2.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #00796b;
  letter-spacing: 0;
  line-height: 1.2;
}

.bp-opt {
  font-style: italic;
  font-weight: 400;
  color: #b0bec5;
}

.bp-tier--filters-only {
  display: grid;
  grid-template-columns: minmax(110px, 1fr) minmax(110px, 1fr) 28px;
  -moz-column-gap: 6px;
       column-gap: 6px;
  align-items: flex-end;
  margin-bottom: 4px;
}

/* Match routing-ruleconfig HL7 Field: SEG . index . index + Value */
.bp-tier--hl7-filters {
  display: grid;
  grid-template-columns: auto minmax(180px, 1fr) 32px;
  align-items: end;
  -moz-column-gap: 10px;
       column-gap: 10px;
  row-gap: 4px;
  margin-bottom: 8px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.bp-hl7-field-block {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  height: 36px;
  margin-top: 8px;
  padding: 0 12px;
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  grid-column: 1;
  align-self: end;
}

.bp-hl7-field-block-label {
  position: absolute;
  top: -10px;
  left: 10px;
  z-index: 3;
  padding: 0 5px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.1;
  color: rgba(0, 0, 0, 0.6);
  background: #fff;
  pointer-events: none;
  white-space: nowrap;
}

.bp-hl7-field-shell {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  width: max-content;
  height: 20px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.bp-hl7-sep {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  padding: 0 1px;
  margin: 0;
}

.bp-hl7-segment-label {
  flex: 0 0 auto;
  width: 4.5ch;
  min-width: 3ch;
  max-width: 5ch;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding: 0;
  color: inherit;
  white-space: nowrap;
}

.bp-hl7-index-input {
  flex: 0 0 auto;
  width: 2.5ch;
  min-width: 1.5ch;
  max-width: 2.5ch;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: inherit;
  box-sizing: border-box;
  cursor: text;
}

.bp-hl7-index-input::placeholder {
  color: rgba(0, 0, 0, 0.38);
}

.bp-tier--hl7-filters .bp-mat-hl7-val {
  grid-column: 2;
  width: 100%;
  min-width: 180px;
  max-width: none;
  margin-top: 8px;
  align-self: end;
}

.bp-tier--hl7-filters .bp-icon-clear {
  grid-column: 3;
  justify-self: end;
  align-self: end;
  margin: 8px 0 4px;
}

.bp-section-divider {
  height: 0;
  margin: 12px 0 10px;
  border: 0;
  border-top: 1px solid #e0e0e0;
}

.bp-selected-attr {
  padding: 4px 0 8px;
}

.bp-selected-attr-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #00796b;
  margin-bottom: 6px;
}

.bp-selected-attr-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bp-selected-attr-row--hl7-leaf {
  flex-wrap: wrap;
  align-items: flex-end;
}

.bp-leaf-seg {
  font-size: 0.875rem;
  font-weight: 700;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #263238;
  margin-right: 2px;
}

.bp-leaf-sep {
  font-weight: 700;
  color: #78909c;
  margin: 0 2px 10px;
  line-height: 1;
}

.bp-mat-leaf.bp-mat-hl7-comp,
.bp-mat-leaf.bp-mat-hl7-sub {
  width: 72px;
  min-width: 72px;
  max-width: 72px;
}

.bp-selected-check {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  color: #2e7d32;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bp-selected-attr-value {
  font-size: 0.875rem;
  font-weight: 700;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #263238;
  word-break: break-all;
}

.bp-mat-attr {
  width: 100%;
}

.bp-mat-val {
  width: 100%;
}

.bp-mat {
  width: 100%;
}

.bp-icon-clear {
  flex-shrink: 0;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  margin: 0;
  color: #78909c;
}
.bp-icon-clear mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  line-height: 15px;
}
.bp-icon-clear:hover {
  color: #c62828;
}

.bp-add-filter {
  margin-top: 2px;
  margin-bottom: 0;
  font-size: 0.625rem;
  line-height: 1.2;
  min-height: 24px;
  height: 24px;
  padding: 0 8px;
  border-color: #e0e0e0;
  color: #00796b;
}

.bp-actions {
  padding: 6px 12px 8px;
  margin: 0;
  border-top: 1px solid #e0e0e0;
  background: #fff;
  flex-wrap: wrap;
  gap: 8px;
}

.bp-apply-error {
  flex: 1 1 100%;
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  color: #c62828;
  text-align: left;
}

.bp-btn-cancel {
  color: #78909c;
  font-weight: 500;
  font-size: 0.75rem;
}

/* Match routing-ruleconfig footer primary actions (Save / Compare): global .btn_style + compact sizing */
.bp-apply-like-footer {
  font-size: 11px !important;
  padding: 4px 12px !important;
  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.18);
  line-height: 1.2 !important;
  min-height: auto !important;
}

.bp-apply-like-footer:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(15, 118, 110, 0.22);
}

/* Material: avoid fighting MDC floating-label math — plain fields stay compact */
::ng-deep .bp-shell {
  /* No floating label: stable single-line infix */
}
::ng-deep .bp-shell .bp-mat.mat-mdc-form-field {
  font-size: 12px;
}
::ng-deep .bp-shell .bp-mat .mat-mdc-form-field-subscript-wrapper {
  margin-top: 0;
  margin-bottom: 0;
}
::ng-deep .bp-shell .bp-mat .mat-mdc-text-field-wrapper {
  border-radius: 4px;
  padding-left: 8px;
  padding-right: 8px;
}
::ng-deep .bp-shell .bp-mat-plain.mat-mdc-form-field .mat-mdc-form-field-infix {
  min-height: 34px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 0;
}
::ng-deep .bp-shell .bp-mat-plain input.mat-mdc-input-element {
  font-size: 12px;
  line-height: 1.25;
  caret-color: #00796b;
}
::ng-deep .bp-shell .bp-mat-plain input.mat-mdc-input-element::placeholder {
  color: rgba(0, 0, 0, 0.38);
  opacity: 1;
}
::ng-deep .bp-shell .bp-mat .mdc-notched-outline .mdc-notched-outline__leading,
::ng-deep .bp-shell .bp-mat .mdc-notched-outline .mdc-notched-outline__notch,
::ng-deep .bp-shell .bp-mat .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #cfd8dc !important;
  border-width: 1px !important;
}
::ng-deep .bp-shell .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__leading,
::ng-deep .bp-shell .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__notch,
::ng-deep .bp-shell .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #009688 !important;
}
::ng-deep .bp-shell .bp-add-filter.mat-mdc-outlined-button,
::ng-deep .bp-shell .bp-add-filter.mdc-button {
  min-height: 24px !important;
  height: 24px !important;
  padding: 0 8px !important;
  font-size: 0.625rem !important;
  line-height: 22px !important;
}
::ng-deep .bp-shell .bp-add-filter .mdc-button__label {
  letter-spacing: 0.01em;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val.mat-mdc-form-field {
  margin: 0;
  width: 100%;
  --mat-form-field-container-height: 36px;
  --mdc-outlined-text-field-container-height: 36px;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-text-field-wrapper {
  min-height: 36px;
  height: 36px;
  width: 100%;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-form-field-infix {
  min-height: 36px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  width: 100%;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-input-element {
  font-size: 12px !important;
  line-height: 20px !important;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-floating-label--float-above {
  top: -9px !important;
  transform: translateY(0) scale(0.75) !important;
}
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__leading,
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__notch,
::ng-deep .bp-shell .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__trailing {
  border-color: #cfd8e3 !important;
  border-width: 1px !important;
}
::ng-deep .bp-shell .bp-mat-attr.mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix {
  min-height: 34px;
  padding-top: 5px;
  padding-bottom: 5px;
}
::ng-deep .bp-shell .bp-mat-attr .mat-mdc-select-value-text {
  font-size: 12px;
  line-height: 1.25;
}

/* mat-select — non-blocking backdrop inside Build Path dialog */
::ng-deep body.routing-mat-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {
  z-index: 10001 !important;
}

@media (max-width: 600px) {
  .bp-tier--filters-only {
    grid-template-columns: 1fr;
    row-gap: 4px;
  }
  .bp-tier--hl7-filters {
    flex-wrap: wrap;
  }
  .bp-tier--hl7-filters {
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
  .bp-hl7-field-block,
  .bp-tier--hl7-filters .bp-mat-hl7-val,
  .bp-tier--hl7-filters .bp-icon-clear {
    grid-column: 1;
  }
  .bp-tier--hl7-filters .bp-icon-clear {
    justify-self: end;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/routing-ruleconfig1/dialogs/build-field-path-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,yFAAA;AAUA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,6GACE;EAOF,cAjBQ;EAkBR,mCAAA;AAdF;;AAiBA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cA/BQ;EAgCR,gBAAA;EACA,gCAAA;AAdF;;AAiBA;EACE,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;AAdF;;AAiBA;EACE,qBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,eAAA;EACA,6BAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,gBAAA;EACA,cArFS;EAsFT,gBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,0EAAA;EACA,4CAAA;AAdF;;AAiBA;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAlHc;EAmHd,iBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,iEAAA;EACA,oBAAA;OAAA,eAAA;EACA,qBAAA;EACA,kBAAA;AAdF;;AAiBA,oEAAA;AACA;EACE,aAAA;EACA,mDAAA;EACA,gBAAA;EACA,qBAAA;OAAA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;EACA,SAAA;AAdF;;AAiBA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,0BAAA;AAdF;;AAiBA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAdF;;AAiBA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,SAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,cA/Qc;EAgRd,kBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAdF;;AAiBA;EACE,eAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,gBAAA;EACA,6EAAA;EACA,cAjSQ;EAkSR,iBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,cAtSc;EAuSd,kBAAA;EACA,cAAA;AAdF;;AAiBA;;EAEE,WAAA;EACA,eAAA;EACA,eAAA;AAdF;;AAiBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,gBAAA;EACA,6EAAA;EACA,cAnUQ;EAoUR,qBAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,cAxVc;AA0UhB;AAgBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,cAAA;AAfJ;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,qBA5WU;EA6WV,cAjXc;AAiWhB;;AAmBA;EACE,qBAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,cArYc;EAsYd,gBAAA;EACA,kBAAA;AAhBF;;AAmBA,yGAAA;AACA;EACE,0BAAA;EACA,4BAAA;EACA,8CAAA;EACA,2BAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,2BAAA;EACA,8CAAA;AAhBF;;AAmBA,iFAAA;AACA;EAgBE,gDAAA;AA/BF;AAgBE;EACE,eAAA;AAdJ;AAiBE;EACE,aAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAhBJ;AAoBE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,iBAAA;EACA,oBAtbY;AAmahB;AAsBE;EACE,0BAAA;EACA,UAAA;AApBJ;AAuBE;;;EAGE,gCAAA;EACA,4BAAA;AArBJ;AAwBE;;;EAGE,gCAAA;AAtBJ;AAyBE;;EAEE,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;AAvBJ;AA0BE;EACE,sBAAA;AAxBJ;AA2BE;EACE,SAAA;EACA,WAAA;EACA,uCAAA;EACA,gDAAA;AAzBJ;AA4BE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AA1BJ;AA6BE;EACE,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,WAAA;AA3BJ;AA8BE;EACE,0BAAA;EACA,4BAAA;AA5BJ;AA+BE;EACE,oBAAA;EACA,+CAAA;AA7BJ;AAgCE;;;EAGE,gCAAA;EACA,4BAAA;AA9BJ;AAiCE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AA/BJ;AAkCE;EACE,eAAA;EACA,iBAAA;AAhCJ;;AAoCA,gEAAA;AACA;EAEE,+BAAA;AAlCF;;AAqCA;EACE,yBAAA;AAlCF;;AAqCA;EACE;IACE,0BAAA;IACA,YAAA;EAlCF;EAqCA;IACE,eAAA;EAnCF;EAsCA;IACE,0BAAA;IACA,YAAA;EApCF;EAuCA;;;IAGE,cAAA;EArCF;EAwCA;IACE,iBAAA;EAtCF;AACF","sourcesContent":["/* Teal “Build Path” — compact; plain outline inputs use floatLabel never + placeholder */\r\n$bp-teal: #00897b;\r\n$bp-teal-mid: #009688;\r\n$bp-teal-light: #4db6ac;\r\n$bp-teal-title: #00796b;\r\n$bp-text: #263238;\r\n$bp-text-muted: #78909c;\r\n$bp-label: #90a4ae;\r\n$bp-border: #e0e0e0;\r\n\r\n.bp-shell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 88vh;\r\n  font-family:\r\n    'Segoe UI',\r\n    system-ui,\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    'Roboto',\r\n    'Helvetica Neue',\r\n    sans-serif;\r\n  color: $bp-text;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.bp-title {\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 32px;\r\n  padding: 4px 12px;\r\n  font-size: 0.9375rem;\r\n  line-height: 1.3;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: $bp-text;\r\n  text-align: left;\r\n  border-bottom: 1px solid $bp-border;\r\n}\r\n\r\n.bp-title.mat-mdc-dialog-title {\r\n  padding: 4px 12px !important;\r\n  margin: 0 !important;\r\n  min-height: 32px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.bp-dialog {\r\n  padding: 6px 12px 8px;\r\n  max-height: calc(88vh - 104px);\r\n  overflow: auto;\r\n  background: #fff;\r\n}\r\n\r\n.bp-form {\r\n  margin-top: 0;\r\n}\r\n\r\n.bp-steps {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.bp-step--filter-only {\r\n  padding: 8px 0 10px;\r\n  border-bottom: none;\r\n}\r\n\r\n.bp-step--filter-not-first {\r\n  padding-top: 14px;\r\n  margin-top: 4px;\r\n  border-top: 1px solid $bp-border;\r\n}\r\n\r\n.bp-steps > .bp-step--filter-only:first-of-type .bp-step-header--segment {\r\n  margin-top: 8px;\r\n}\r\n\r\n.bp-step-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.bp-filter-optional-label {\r\n  font-size: 0.625rem;\r\n  font-weight: 500;\r\n  color: $bp-label;\r\n  line-height: 1.2;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.bp-step-num {\r\n  flex-shrink: 0;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.58rem;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  background: linear-gradient(160deg, $bp-teal-light 0%, $bp-teal 55%, $bp-teal-title 100%);\r\n  box-shadow: 0 1px 3px rgba(0, 105, 92, 0.16);\r\n}\r\n\r\n.bp-step-heading {\r\n  margin: 0;\r\n  flex: 1 1 auto;\r\n  min-width: 2.5rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: $bp-teal-title;\r\n  letter-spacing: 0;\r\n  line-height: 1.2;\r\n}\r\n\r\n.bp-opt {\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  color: #b0bec5;\r\n}\r\n\r\n.bp-tier--filters-only {\r\n  display: grid;\r\n  grid-template-columns: minmax(110px, 1fr) minmax(110px, 1fr) 28px;\r\n  column-gap: 6px;\r\n  align-items: flex-end;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* Match routing-ruleconfig HL7 Field: SEG . index . index + Value */\r\n.bp-tier--hl7-filters {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(180px, 1fr) 32px;\r\n  align-items: end;\r\n  column-gap: 10px;\r\n  row-gap: 4px;\r\n  margin-bottom: 8px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.bp-hl7-field-block {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 36px;\r\n  height: 36px;\r\n  margin-top: 8px;\r\n  padding: 0 12px;\r\n  border: 1px solid #cfd8e3;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  grid-column: 1;\r\n  align-self: end;\r\n}\r\n\r\n.bp-hl7-field-block-label {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 10px;\r\n  z-index: 3;\r\n  padding: 0 5px;\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  line-height: 1.1;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  background: #fff;\r\n  pointer-events: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bp-hl7-field-shell {\r\n  display: inline-flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 0;\r\n  width: max-content;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.bp-hl7-sep {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  user-select: none;\r\n  padding: 0 1px;\r\n  margin: 0;\r\n}\r\n\r\n.bp-hl7-segment-label {\r\n  flex: 0 0 auto;\r\n  width: 4.5ch;\r\n  min-width: 3ch;\r\n  max-width: 5ch;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 20px;\r\n  text-align: left;\r\n  padding: 0;\r\n  color: inherit;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bp-hl7-index-input {\r\n  flex: 0 0 auto;\r\n  width: 2.5ch;\r\n  min-width: 1.5ch;\r\n  max-width: 2.5ch;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n  cursor: text;\r\n}\r\n\r\n.bp-hl7-index-input::placeholder {\r\n  color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n.bp-tier--hl7-filters .bp-mat-hl7-val {\r\n  grid-column: 2;\r\n  width: 100%;\r\n  min-width: 180px;\r\n  max-width: none;\r\n  margin-top: 8px;\r\n  align-self: end;\r\n}\r\n\r\n.bp-tier--hl7-filters .bp-icon-clear {\r\n  grid-column: 3;\r\n  justify-self: end;\r\n  align-self: end;\r\n  margin: 8px 0 4px;\r\n}\r\n\r\n.bp-section-divider {\r\n  height: 0;\r\n  margin: 12px 0 10px;\r\n  border: 0;\r\n  border-top: 1px solid $bp-border;\r\n}\r\n\r\n.bp-selected-attr {\r\n  padding: 4px 0 8px;\r\n}\r\n\r\n.bp-selected-attr-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: $bp-teal-title;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.bp-selected-attr-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.bp-selected-attr-row--hl7-leaf {\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n}\r\n\r\n.bp-leaf-seg {\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\r\n  color: $bp-text;\r\n  margin-right: 2px;\r\n}\r\n\r\n.bp-leaf-sep {\r\n  font-weight: 700;\r\n  color: $bp-text-muted;\r\n  margin: 0 2px 10px;\r\n  line-height: 1;\r\n}\r\n\r\n.bp-mat-leaf.bp-mat-hl7-comp,\r\n.bp-mat-leaf.bp-mat-hl7-sub {\r\n  width: 72px;\r\n  min-width: 72px;\r\n  max-width: 72px;\r\n}\r\n\r\n.bp-selected-check {\r\n  flex-shrink: 0;\r\n  width: 22px;\r\n  height: 22px;\r\n  font-size: 22px;\r\n  line-height: 22px;\r\n  color: #2e7d32;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.bp-selected-attr-value {\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\r\n  color: $bp-text;\r\n  word-break: break-all;\r\n}\r\n\r\n.bp-mat-attr {\r\n  width: 100%;\r\n}\r\n\r\n.bp-mat-val {\r\n  width: 100%;\r\n}\r\n\r\n.bp-mat {\r\n  width: 100%;\r\n}\r\n\r\n.bp-icon-clear {\r\n  flex-shrink: 0;\r\n  width: 28px !important;\r\n  height: 28px !important;\r\n  padding: 0 !important;\r\n  margin: 0;\r\n  color: $bp-text-muted;\r\n\r\n  mat-icon {\r\n    font-size: 15px;\r\n    width: 15px;\r\n    height: 15px;\r\n    line-height: 15px;\r\n  }\r\n\r\n  &:hover {\r\n    color: #c62828;\r\n  }\r\n}\r\n\r\n.bp-add-filter {\r\n  margin-top: 2px;\r\n  margin-bottom: 0;\r\n  font-size: 0.625rem;\r\n  line-height: 1.2;\r\n  min-height: 24px;\r\n  height: 24px;\r\n  padding: 0 8px;\r\n  border-color: $bp-border;\r\n  color: $bp-teal-title;\r\n}\r\n\r\n.bp-actions {\r\n  padding: 6px 12px 8px;\r\n  margin: 0;\r\n  border-top: 1px solid $bp-border;\r\n  background: #fff;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.bp-apply-error {\r\n  flex: 1 1 100%;\r\n  margin: 0;\r\n  font-size: 12px;\r\n  line-height: 1.35;\r\n  color: #c62828;\r\n  text-align: left;\r\n}\r\n\r\n.bp-btn-cancel {\r\n  color: $bp-text-muted;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n/* Match routing-ruleconfig footer primary actions (Save / Compare): global .btn_style + compact sizing */\r\n.bp-apply-like-footer {\r\n  font-size: 11px !important;\r\n  padding: 4px 12px !important;\r\n  box-shadow: 0 1px 2px rgba(15, 118, 110, 0.18);\r\n  line-height: 1.2 !important;\r\n  min-height: auto !important;\r\n}\r\n\r\n.bp-apply-like-footer:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 3px 8px rgba(15, 118, 110, 0.22);\r\n}\r\n\r\n/* Material: avoid fighting MDC floating-label math — plain fields stay compact */\r\n::ng-deep .bp-shell {\r\n  .bp-mat.mat-mdc-form-field {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .bp-mat .mat-mdc-form-field-subscript-wrapper {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .bp-mat .mat-mdc-text-field-wrapper {\r\n    border-radius: 4px;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n  }\r\n\r\n  /* No floating label: stable single-line infix */\r\n  .bp-mat-plain.mat-mdc-form-field .mat-mdc-form-field-infix {\r\n    min-height: 34px;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-top: 0;\r\n  }\r\n\r\n  .bp-mat-plain input.mat-mdc-input-element {\r\n    font-size: 12px;\r\n    line-height: 1.25;\r\n    caret-color: $bp-teal-title;\r\n  }\r\n\r\n  .bp-mat-plain input.mat-mdc-input-element::placeholder {\r\n    color: rgba(0, 0, 0, 0.38);\r\n    opacity: 1;\r\n  }\r\n\r\n  .bp-mat .mdc-notched-outline .mdc-notched-outline__leading,\r\n  .bp-mat .mdc-notched-outline .mdc-notched-outline__notch,\r\n  .bp-mat .mdc-notched-outline .mdc-notched-outline__trailing {\r\n    border-color: #cfd8dc !important;\r\n    border-width: 1px !important;\r\n  }\r\n\r\n  .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__leading,\r\n  .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__notch,\r\n  .bp-mat.mat-focused .mdc-notched-outline .mdc-notched-outline__trailing {\r\n    border-color: $bp-teal-mid !important;\r\n  }\r\n\r\n  .bp-add-filter.mat-mdc-outlined-button,\r\n  .bp-add-filter.mdc-button {\r\n    min-height: 24px !important;\r\n    height: 24px !important;\r\n    padding: 0 8px !important;\r\n    font-size: 0.625rem !important;\r\n    line-height: 22px !important;\r\n  }\r\n\r\n  .bp-add-filter .mdc-button__label {\r\n    letter-spacing: 0.01em;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val.mat-mdc-form-field {\r\n    margin: 0;\r\n    width: 100%;\r\n    --mat-form-field-container-height: 36px;\r\n    --mdc-outlined-text-field-container-height: 36px;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-text-field-wrapper {\r\n    min-height: 36px;\r\n    height: 36px;\r\n    width: 100%;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-form-field-infix {\r\n    min-height: 36px !important;\r\n    padding-top: 8px !important;\r\n    padding-bottom: 8px !important;\r\n    width: 100%;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mat-mdc-input-element {\r\n    font-size: 12px !important;\r\n    line-height: 20px !important;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-floating-label--float-above {\r\n    top: -9px !important;\r\n    transform: translateY(0) scale(0.75) !important;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__leading,\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__notch,\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val .mdc-notched-outline__trailing {\r\n    border-color: #cfd8e3 !important;\r\n    border-width: 1px !important;\r\n  }\r\n\r\n  .bp-mat-attr.mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix {\r\n    min-height: 34px;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n  }\r\n\r\n  .bp-mat-attr .mat-mdc-select-value-text {\r\n    font-size: 12px;\r\n    line-height: 1.25;\r\n  }\r\n}\r\n\r\n/* mat-select — non-blocking backdrop inside Build Path dialog */\r\n::ng-deep body.routing-mat-select-open\r\n  .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {\r\n  z-index: 10001 !important;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .bp-tier--filters-only {\r\n    grid-template-columns: 1fr;\r\n    row-gap: 4px;\r\n  }\r\n\r\n  .bp-tier--hl7-filters {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .bp-tier--hl7-filters {\r\n    grid-template-columns: 1fr;\r\n    row-gap: 8px;\r\n  }\r\n\r\n  .bp-hl7-field-block,\r\n  .bp-tier--hl7-filters .bp-mat-hl7-val,\r\n  .bp-tier--hl7-filters .bp-icon-clear {\r\n    grid-column: 1;\r\n  }\r\n\r\n  .bp-tier--hl7-filters .bp-icon-clear {\r\n    justify-self: end;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
